import React from "react"
import { Button, Card, CardActions, CardContent, CardMedia, Chip, Grid2, Stack, Typography } from "@mui/material"
import { Prompt } from "@/shared/types/prompt"

interface PromptCardsGridProps {
  prompts: Prompt[]
  onUsePrompt: (promptId: string) => void
}

const PromptCardsGrid: React.FC<PromptCardsGridProps> = ({ prompts, onUsePrompt }) => {
  if (prompts.length === 0) {
    return null
  }

  return (
    <Grid2 container spacing={2}>
      {prompts.map(prompt => (
        <Grid2
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}
          key={prompt.id}>
          <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <CardMedia
              sx={{ height: 140 }}
              image={prompt.exampleUrl || "https://via.placeholder.com/600x400?text=No+Image"}
              title={prompt.name}
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Stack spacing={1}>
                <Typography gutterBottom variant="body1" component="div" sx={{ wordBreak: "break-word" }}>
                  {prompt.name}
                </Typography>
              </Stack>
            </CardContent>
            <CardActions sx={{ justifyContent: "space-between" }}>
              {prompt.categoryName ? <Chip label={prompt.categoryName} size="small" /> : null}
              <Button size="small" onClick={() => onUsePrompt(prompt.id)}>
                Use
              </Button>
            </CardActions>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  )
}

export default PromptCardsGrid
